// extracted by mini-css-extract-plugin
module.exports = {"createCompanyForm":"CreateCompanyModal_createCompanyForm__Oxgkw"};